export default __webpack_public_path__ + "static/property1-379e29c72107106fafb9fc598acb0d87.png";